// stores/shift.js
import { defineStore } from 'pinia'
export const useShiftStore = defineStore('shift', {
  state: () => ({
    lastUpdate: Date.now(),
    currentDate: new Date() // Store the currently selected month/year from TimeReporting
  }),
  actions: {
    notifyShiftsChanged() {
      this.lastUpdate = Date.now()
    },
    setCurrentDate(date) {
      this.currentDate = date
    }
  }
})